import React, { Fragment, useEffect, useState } from "react";
import { ComboBox, FormSection } from "../../../components";

export default function FormOpcoesApresentacaoFlexivel({
  caracteristicas,
  handleConsulta,
}) {
  const [consulta, setConsulta] = useState("");

  const handleInput = (value, name) => {
    setConsulta({ ...consulta, [name]: value });
  };

  useEffect(() => {
    handleConsulta(consulta);
    // eslint-disable-next-line
  }, [consulta]);

  return (
    <div className="main-content mt-1">
      <FormSection
        title="Dados flexíveis"
        borderBottomWidth={1}
        fontSizeClass="fs-18px"
      >
        <ComboBox items={[]} displayName="nome" placeholder="Opção 1" />
        <ComboBox items={[]} displayName="nome" placeholder="Opção 2" />
        <ComboBox items={[]} displayName="nome" placeholder="Opção 3" />
        <ComboBox items={[]} displayName="nome" placeholder="Opção 4" />
      </FormSection>
    </div>
  );
}
